import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import '@/assets/scss/global.scss'
// 创建应用实例
const app = createApp(App);

// 注册Element Plus图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
// 1. 创建 Pinia 实例
const pinia = createPinia()
// 安装插件
app.use(pinia);
app.use(router);
app.use(ElementPlus, {
  locale: zhCn,
});

// 挂载应用
app.mount('#app');

    